import { render, staticRenderFns } from "./fieldSet.vue?vue&type=template&id=720cc290&scoped=true&"
import script from "./fieldSet.vue?vue&type=script&lang=js&"
export * from "./fieldSet.vue?vue&type=script&lang=js&"
import style0 from "./fieldSet.vue?vue&type=style&index=0&id=720cc290&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720cc290",
  null
  
)

export default component.exports